import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const baseService = createCrudService("shift-note-questions", [], router);

export const shiftNoteQuestionsService = {
  ...baseService,
  getByServiceCode: (code) => api.getCall(`/api/shift-note-questions/by-service-code/${code}`),
};
